import React from 'react';
import ReactDOM from 'react-dom';
import { DesignerUi } from '../ui/DesignerUi';
import { PreviewUi } from '../ui/PreviewUi';
import { IDT } from '@gift/types/IDT';
import { Paintable } from 'ff-canvas';
import { createI18n } from '../translations/localization';
import { isIe } from '../helpers/browser-detection';
import { AppStore, createStore } from '@gift/website-state/store';
import { reportConfigurationErrors } from '@gift/common/site/reportConfigurationErrors';
import { bindSiteEvents, fireFocusEventToSite } from '@gift/common/site/siteEventBindings';
import { selectVariablePaintables } from '@gift/website-state/slices/variablesSlice';
import { loadFont } from '@gift/website-state/apis/loadFonts';

const hydrate = async (options: IDT.Options) => {
    applyOptions(options);
    const store = createStore(window.__idt_state);
    const i18n = createI18n(window.__idt_language ?? 'nl-NL');
    startup(store);
    ReactDOM.hydrate(<DesignerUi store={store} i18n={i18n} />, options.containers.designer);
    ReactDOM.hydrate(<PreviewUi store={store} i18n={i18n} />, options.containers.preview);
};

const render = async (options: IDT.Options) => {
    applyOptions(options);
    const store = createStore(window.__idt_state);
    const i18n = createI18n(window.__idt_language ?? 'nl-NL');
    startup(store);
    ReactDOM.render(<DesignerUi store={store} i18n={i18n} />, options.containers.designer);
    ReactDOM.render(<PreviewUi store={store} i18n={i18n} />, options.containers.preview);
};

const applyOptions = (options: IDT.Options) => {
    reportConfigurationErrors(options);
    bindSiteEvents(options.events);
};

const startup = (store: AppStore) => {
    fireFocusEventOnDesignChange(store);
    loadFonts(store);
};

const fireFocusEventOnDesignChange = (store: AppStore) => {
    let currentPaintables: Paintable[];
    store.subscribe(() => {
        const previousPaintables = currentPaintables;
        currentPaintables = selectVariablePaintables(store.getState(), 'mockup');
        if (previousPaintables && currentPaintables !== previousPaintables) {
            fireFocusEventToSite({ name: 'focus' });
        }
    });
};

const loadFonts = (store: AppStore) => {
    if (!isIe()) {
        const { fonts } = store.getState();
        for (const font of fonts) {
            store.dispatch(loadFont(font));
        }
    }
};

export const idtApi = {
    hydrate,
    render
};
